import React from 'react'
import { AppRunProgress } from '@components'
import { Box } from '@mui/material'
import { globalExecutionsTableBatchCellData } from 'Pages/Admin/GlobalExecution/@signals'
import { REPORT_STATUS } from '@constants'
import { reportSearchesModalId } from '@signals'
import { useComputed } from '@preact/signals-react'



export default function historyColumn() {

	return [{
		name: 'id_batch', label: 'Status',
		options: {
			display: 'excluded',
		},
	},{
		name: 'id_batch', label: 'Status',
		options: {
			filter: false,
			customBodyRowRenderLite: (idBatch, row) => <CellContent idBatch={idBatch} row={row}/>,
		},
	}]
}


function CellContent({ idBatch, row }) {
	const rowData = useComputed(() => ({ ...row, ...globalExecutionsTableBatchCellData.value[idBatch] }))

	return <Box sx={{ display: 'flex', justifyContent: 'center', width: 1 }}>
		<AppRunProgress
			label={!rowData.value?.generating && 'Running'}
			actual={rowData.value?.percentage}
			total={100}
			done={rowData.value?.completeTasksString}
			totalText={rowData.value?.totalTasksString}
			generating={rowData.value?.generating}
			onClick={() => {
				if (rowData.value?.status !== REPORT_STATUS.GENERATING) {
					reportSearchesModalId.value = rowData.value?.id_batch
				}
			}}
		/>
	</Box>
}
